import React, { Suspense, lazy, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './hooks/useAuth.jsx';
import ProtectedRoute from './components/ProtectedRoute';
import { MainLayout } from './components/MainLayout';
// Lazy loaded pages (code splitting)
const Login = lazy(() => import('./pages/Login'));
const RecuperarSenha = lazy(() => import('./pages/RecuperarSenha'));
const RedefinirSenha = lazy(() => import('./pages/RedefinirSenha'));
const Dashboard = lazy(() => import('./pages/Dashboard'));
const Eventos = lazy(() => import('./pages/Eventos'));
const NovoEvento = lazy(() => import('./pages/NovoEvento'));
const EditarEvento = lazy(() => import('./pages/EditarEvento'));
const EventoDetalhes = lazy(() => import('./pages/EventoDetalhes'));
const DisponibilidadeVagas = lazy(() => import('./pages/DisponibilidadeVagas'));
const Logs = lazy(() => import('./pages/Logs'));
const Relatorios = lazy(() => import('./pages/Relatorios'));
const Configuracoes = lazy(() => import('./pages/Configuracoes'));
const AI = lazy(() => import('./pages/AI'));
import './App.css';
import './styles/date-picker-mobile.css';
import { ErrorBoundary } from './components/ErrorBoundary.jsx';

function App() {
  // Criar cliente do React Query dentro do componente
  const [queryClient] = useState(() => new QueryClient({
    defaultOptions: {
      queries: {
        retry: 1,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 5, // 5 minutos
      },
    },
  }));
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Router>
          <Suspense fallback={<div style={{padding:'2rem', textAlign:'center'}}>Carregando...</div>}>
            <ErrorBoundary>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/recuperar-senha" element={<RecuperarSenha />} />
              <Route path="/redefinir-senha" element={<RedefinirSenha />} />
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <MainLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<Dashboard />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="eventos" element={<Eventos />} />
                <Route path="eventos/novo" element={<NovoEvento />} />
                <Route path="eventos/:id/editar" element={<EditarEvento />} />
                <Route path="eventos/:id" element={<EventoDetalhes />} />
                <Route path="disponibilidade" element={<DisponibilidadeVagas />} />
                <Route path="configuracoes" element={<Configuracoes />} />
                <Route path="ai" element={<AI />} />
                <Route path="logs" element={<Logs />} />
                <Route path="relatorios" element={<Relatorios />} />
              </Route>
            </Routes>
            </ErrorBoundary>
          </Suspense>
        </Router>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;

